<template>
  <div class="have-wiring">
    <div class="search-pane">
      <pro-search
        :fileds="SearchFiled"
        :form="queryForm"
        @search="toSearch"
        @reset="handleReset"
      />
      <div class="search-btn">
        <a-button
          :loading="exportLoading"
          @click="handleExport"
        >导出</a-button>
      </div>
    </div>
    <a-table
      :columns="AllWiringColumns"
      :data-source="dataList"
      bordered
      :pagination="pagination"
      class="wiring-table table-multip"
      row-key="id"
      :scroll="{ x: 'calc(800px + 50%)' }"
      :row-class-name="rowClass"
      :custom-row="customRow"
      @change="tableChange"
    >
      <template
        slot="supplierCode"
        slot-scope="text"
      >
        <a-tooltip
          v-if="text.length > 20"
          placement="top"
        >
          <template slot="title">
            <span>{{ text }}</span>
          </template>
          <span>{{ conductLength(text) }}</span>
        </a-tooltip>
        <span v-else>{{ conductLength(text) }}</span>
      </template>
      <template
        slot="warehouseCode"
        slot-scope="text"
      >
        <a-tooltip
          v-if="text.length > 20"
          placement="top"
        >
          <template slot="title">
            <span>{{ text }}</span>
          </template>
          <span>{{ conductLength(text) }}</span>
        </a-tooltip>
        <span v-else>{{ conductLength(text) }}</span>
      </template>

      <!-- <template slot="action" slot-scope="text, record">
                <div v-if="record.ext && record.ext.feeItems">
                    <p v-if="record.ext.feeItems.handlingCharges"><span>装卸费：</span> {{ record.ext.feeItems.handlingCharges }}</p>
                    <p v-if="record.ext.feeItems.escortFees"><span>押车费：</span> {{ record.ext.feeItems.escortFees }}</p>
                    <p v-if="record.ext.feeItems.escortTime" class="action-time"><span>押车时长：</span> {{ record.ext.feeItems.escortTime }}h</p>
                </div>
                <div v-else><a-button type="link" :disabled="record.unifyOrderCode ? false : true" @click="addModal(record)">添加</a-button></div>
            </template> -->
    </a-table>
    <a-modal
      v-model="visible"
      title="其他费用项"
      ok-text="确认"
      cancel-text="取消"
      @ok="hideModal"
      @cancel="cancelModal"
    >
      <p
        v-for="(item, index) in feeItem"
        :key="index"
      >
        <a-row
          v-if="item.type === 'YC'"
          class="visible-row"
        >
          <a-col :span="8">
            <a-select
              ref="select"
              v-model="item.type"
              allow-clear
              style="width: 100%"
              placeholder="请选择"
            >
              <a-select-option value="YC">押车费</a-select-option>
              <a-select-option value="ZX">装卸费</a-select-option>
            </a-select>
          </a-col>
          <a-col
            :span="1"
            style="text-align: center"
          >=</a-col>
          <a-col :span="8">
            <a-input-number
              id="inputNumber"
              v-model="item.value"
              :min="0"
              style="width: 70%"
              placeholder="请输入数值"
            />
            元
          </a-col>
          <a-col
            v-if="feeItem.length > 1"
            :span="2"
            style="text-align: left"
          >
            <a-button
              type="link"
              danger
              style="color: rgb(120, 115, 115)"
              @click="deleteFeeItems(index)"
            >
              删除
            </a-button>
          </a-col>
          <a-col
            v-if="index < 1"
            :span="6"
            style="text-align: left"
          >
            <a-button
              type="link"
              @click="addFeeItems"
            >
              添加费用项
            </a-button>
          </a-col>
        </a-row>
        <a-row
          v-if="item.type === 'YC'"
          class="visible-row"
        >
          <a-col
            :span="8"
            style="text-align: right;"
          > <span>押车时长</span> </a-col>
          <a-col
            :span="1"
            style="text-align: center"
          >=</a-col>
          <a-col :span="8">
            <a-input-number
              id="inputNumber"
              v-model="item.valueTime"
              :min="0"
              style="width: 70%"
              placeholder="请输入数值"
            />
            小时
          </a-col>
        </a-row>
        <a-row
          v-else
          class="visible-row"
        >
          <a-col :span="8">
            <a-select
              ref="select"
              v-model="item.type"
              allow-clear
              style="width: 100%"
              placeholder="请选择"
              @change="(val) => changeType(item, val)"
            >
              <a-select-option value="YC">押车费</a-select-option>
              <a-select-option value="ZX">装卸费</a-select-option>
            </a-select>
          </a-col>
          <a-col
            :span="1"
            style="text-align: center"
          >=</a-col>
          <a-col :span="8">
            <a-input-number
              id="inputNumber"
              v-model="item.value"
              :min="0"
              style="width: 70%"
              placeholder="请输入数值"
            />
            元
          </a-col>
          <a-col
            v-if="feeItem.length > 1"
            :span="2"
            style="text-align: left"
          >
            <a-button
              type="link"
              danger
              style="color: rgb(120, 115, 115)"
              @click="deleteFeeItems(index)"
            >
              删除
            </a-button>
          </a-col>
          <a-col
            v-if="index < 1"
            :span="6"
            style="text-align: left"
          >
            <a-button
              type="link"
              @click="addFeeItems"
            >
              添加费用项
            </a-button>
          </a-col>
        </a-row>
      </p>
      <p></p>
    </a-modal>
    <WiringDialog
      ref="HaveWiringDialog"
      @cancel="handleCancel"
      @delete="onDelete"
    />
  </div>
</template>

<script>
import moment from 'moment';

import { getToken, getAppToken } from '@/utils/auth';
import { filterNull } from '@/utils/util';
import ProSearch from '@/components/TableSearch/index.vue';
import {
  haveWiringColumns,
  haveAllWiringColumns,
  carLengthList,
  PLAN_STATUS,
  SearchFiled
} from '../const';
import WiringDialog from './WiringDialog.vue';
import {
  getPlanInfoPage,
  planLineDelete,
  addOthersFee,
  getDetailPage,
  starbucksExport
} from '../../api';
import Service from '../../../../../../env/index';

// 选框为下单多选框，值为固定枚举值，包含【7.6米】【9.6米】【12.5米】【13.5米】【15米】
export default {
  name: 'HaveWiring',
  components: {
    WiringDialog,
    ProSearch
  },
  props: {
    checkTab: {
      type: String,
      default: ''
    },
    isPlanning: {
      type: Boolean,
      default: false
    },
    planCode: {
      type: String,
      default: ''
    },
    plan: {
      type: Object,
      default: () => {}
    },
    refreshTime: {
      type: Date,
      default: ''
    }
  },
  data() {
    return {
      key: new Date(),
      dataSource: [],
      nameCounts: {}, // 存储每个name的记录数量
      feeItem: [{ name: '', value: '' }],
      visible: false,
      queryForm: {
        loadFactorIsRight: '',
        isChanged: ''
      },
      dataList: [],
      showAll: true,
      PLAN_STATUS,
      createTime: [],
      showTime: {
        format: 'HH:mm:ss',
        defaultValue: [
          moment('00:00:00', 'HH:mm:ss'),
          moment('23:59:59', 'HH:mm:ss')
        ]
      },
      haveWiringColumns,
      haveAllWiringColumns,
      carLengthList,
      layout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 }
      },
      pagination: {
        current: 1,
        total: 0,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize;
        },
        showQuickJumper: true,
        showTotal: (total) => `共 ${total} 条`
      },
      renderLine: [],
      SearchFiled,
      addInfo: null,
      exportLoading: false
    };
  },
  computed: {
    formatTime() {
      return (text) => moment(text).format('YYYY-MM-DD');
    },
    // 计算相同线路的拍数
    totalSkuPallet() {
      return (lineCode) => {
        let totalPallet = 0;
        const lineList = this.dataList.filter(
          (item) => item.lineCode === lineCode
        );
        lineList.forEach((item) => {
          totalPallet += item.skuPalletUpper;
        });
        return totalPallet;
      };
    },
    carlengthText() {
      return (value) => {
        if (value) {
          return value.length > 20 ? (
            <a-tooltip>
              <template slot="title">{value}</template>
              {value.length > 20 ? `${value.substring(0, 19)}...` : value}
            </a-tooltip>
          ) : (
            value
          );
        }
        return '--';
      };
    },
    orderText() {
      return (value, row) => {
        if (value) {
          return value.length > 20 ? (
            <a-tooltip>
              <template slot="title">{value}</template>
              {value.length > 20 ? `${value.substring(0, 19)}...` : value}
            </a-tooltip>
          ) : (
            value
          );
        }
        return row.unifyOrderFailedReason ? (
          <div style="color:red">{row.unifyOrderFailedReason}</div>
        ) : (
          '--'
        );
      };
    },
    addCarlengthText() {
      return (value, row) => {
        if (value) {
          if (row.ext && row.ext.feeItems) {
            return (
              <div>
                {row.ext.feeItems.handlingCharges ? (
                  <p>
                    <span>装卸费：</span>{' '}
                    {row.ext.feeItems.handlingCharges
                      ? row.ext.feeItems.handlingCharges
                      : 0}
                  </p>
                ) : null}
                {row.ext.feeItems.escortFees ? (
                  <p>
                    <span>押车费：</span>{' '}
                    {row.ext.feeItems.escortFees
                      ? row.ext.feeItems.escortFees
                      : 0}
                  </p>
                ) : null}
                {row.ext.feeItems.escortTime ? (
                  <p class="action-time">
                    <span>押车时长：</span>{' '}
                    {row.ext.feeItems.escortTime
                      ? row.ext.feeItems.escortTime
                      : 0}
                    h
                  </p>
                ) : null}
              </div>
            );
          }
          return (
            <a-button
              type="link"
              disabled={!row.unifyOrderCode}
              onClick={() => this.addModal(row)}
            >
              添加
            </a-button>
          );
        }
        return (
          <a-button
            type="link"
            disabled={!row.unifyOrderCode}
            onClick={() => this.addModal(row)}
          >
            添加
          </a-button>
        );
      };
    },
    WiringColumns() {
      return [
        {
          title: '线路',
          dataIndex: 'line',
          customRender: (value, row) => {
            const obj = {
              children: this.carlengthText(value),
              attrs: {}
            };
            obj.attrs.rowSpan = row.rowSpan;
            return obj;
          },
          width: 140
        },
        ...this.haveWiringColumns,
        {
          title: '车长',
          dataIndex: 'carLength',
          slots: { title: 'carLength' },
          customRender: (value, row) => {
            const obj = {
              children: this.carlengthText(value),
              attrs: {}
            };
            obj.attrs.rowSpan = row.rowSpan;
            return obj;
          },
          width: 120
        },
        ...(this.isPlanning
          ? []
          : [
              {
                title: '预估运费(元)',
                dataIndex: 'transportPrice',
                customRender: (value, row) => {
                  const obj = {
                    children: value,
                    attrs: {}
                  };
                  obj.attrs.rowSpan = row.rowSpan;
                  return obj;
                },
                width: 120
              },
              {
                title: '单托成本(元)',
                dataIndex: 'singlePalletCost',
                customRender: (value, row) => {
                  const obj = {
                    children: value,
                    attrs: {}
                  };
                  obj.attrs.rowSpan = row.rowSpan;
                  return obj;
                },
                width: 120
              },
              {
                title: '点位费(元)',
                dataIndex: 'pointPrice',
                customRender: (value, row) => {
                  const obj = {
                    children: value,
                    attrs: {}
                  };
                  obj.attrs.rowSpan = row.rowSpan;
                  return obj;
                },
                width: 120
              }
            ]),

        {
          title: '满载率目标',
          dataIndex: 'aimLoadFactor',
          customRender: (value, row) => ({
            children: value ? `${value * 100}%` : '-',
            attrs: {
              rowSpan: row.rowSpan
            }
          }),
          width: 120
        },
        {
          title: '装载量(托)',
          dataIndex: 'skuPalletUpper2',
          customRender: (value, row) => {
            const obj = {
              children: this.totalSkuPallet(row.lineCode),
              attrs: {}
            };
            obj.attrs.rowSpan = row.rowSpan;
            return obj;
          },
          width: 100
        },
        {
          title: '装载率',
          dataIndex: 'loadRate',
          customRender: (value, row) => {
            const obj = {
              children: value ? `${value}%` : '',
              attrs: {}
            };
            obj.attrs.rowSpan = row.rowSpan;
            return obj;
          },
          width: 80
        },
        {
          title: '满载率是否达标',
          dataIndex: 'loadFactorIsRight',
          customRender: (value, row) => {
            const obj = {
              children: value ? '是' : '否',
              attrs: {}
            };
            obj.attrs.rowSpan = row.rowSpan;
            return obj;
          },
          width: 120
        },

        ...(this.isPlanning
          ? [
              {
                title: '费用差',
                dataIndex: 'priceDiff',
                customRender: (value, row) => {
                  const obj = {
                    children: value,
                    attrs: {}
                  };
                  obj.attrs.rowSpan = row.rowSpan;
                  return obj;
                },
                width: 120
              }
            ]
          : [
              {
                title: '价格是否审批',
                dataIndex: 'lineIsExamine',
                customRender: (value, row) => {
                  const obj = {
                    children: value ? '是' : '否',
                    attrs: {}
                  };
                  obj.attrs.rowSpan = row.rowSpan;
                  return obj;
                },
                width: 120
              },
              {
                title: '费用差',
                dataIndex: 'priceDiff',
                customRender: (value, row) => {
                  const obj = {
                    children: value,
                    attrs: {}
                  };
                  obj.attrs.rowSpan = row.rowSpan;
                  return obj;
                },
                width: 120
              }
            ]),

        {
          title: '是否为变更计划',
          dataIndex: 'isChanged',
          customRender: (value, row) => {
            const obj = {
              children: value ? '是' : '否',
              attrs: {}
            };
            obj.attrs.rowSpan = row.rowSpan;
            return obj;
          },
          width: 120
        }
      ];
    },
    AllWiringColumns() {
      return [
        {
          title: '线路',
          dataIndex: 'lineId',
          fixed: 'left',
          customRender: (value, row) => {
            const obj = {
              children: this.carlengthText(value),
              attrs: {}
            };
            obj.attrs.rowSpan = row.rowSpan;
            return obj;
          },
          width: 200
        },
        ...this.haveAllWiringColumns,
        {
          title: '货品编码',
          dataIndex: 'itemCode',
          customRender: (value, row) => {
            return value || '--';
          },
          width: 160
        },
        {
          title: '货品重量',
          dataIndex: 'totalWeight',
          customRender: (value, row) => {
            return value || '--';
          },
          width: 100
        },
        {
          title: '车长',
          dataIndex: 'vehicleType',
          slots: { title: 'vehicleType' },
          customRender: (value, row) => {
            const obj = {
              children: this.carlengthText(value),
              attrs: {}
            };
            obj.attrs.rowSpan = row.rowSpan;
            return obj;
          },
          width: 120
        },

        {
          title: '装载量(拍)',
          dataIndex: 'vehiclePalletCount',
          customRender: (value, row) => {
            const obj = {
              children: this.carlengthText(value),
              // children: this.totalSkuPallet(row.lineCode),
              attrs: {}
            };
            obj.attrs.rowSpan = row.rowSpan;
            return obj;
          },
          width: 100
        },
        // {
        //     title: '装载率',
        //     dataIndex: 'vehicleLoadingRate',
        //     customRender: (value, row) => {
        //         const obj = {
        //             children: value ? `${(value * 10000) / 100}%` : '',
        //             attrs: {}
        //         };
        //         obj.attrs.rowSpan = row.rowSpan;
        //         return obj;
        //     },
        //     width: 80
        // },

        {
          title: '满载计算维度',
          dataIndex: 'transportType',
          customRender: (value, row) => {
            const obj = {
              children: this.carlengthText(value),
              attrs: {}
            };
            obj.attrs.rowSpan = row.rowSpan;
            return obj;
          },
          width: 160
        },
        {
          title: '车型重量',
          dataIndex: 'vehicleWeight',
          customRender: (value, row) => {
            const obj = {
              children: this.carlengthText(value),
              attrs: {}
            };
            obj.attrs.rowSpan = row.rowSpan;
            return obj;
          },
          width: 100
        },
        {
          title: '拍数满载率',
          dataIndex: 'vehicleLoadingRatePallet',
          customRender: (value, row) => {
            const obj = {
              children: this.carlengthText(value),
              attrs: {}
            };
            obj.attrs.rowSpan = row.rowSpan;
            return obj;
          },
          width: 100
        },
        {
          title: '体积满载率',
          dataIndex: 'vehicleLoadingRateVolume',
          customRender: (value, row) => {
            const obj = {
              children: this.carlengthText(value),
              attrs: {}
            };
            obj.attrs.rowSpan = row.rowSpan;
            return obj;
          },
          width: 100
        },
        {
          title: '重量满载率',
          dataIndex: 'vehicleLoadingRateWeight',
          customRender: (value, row) => {
            const obj = {
              children: this.carlengthText(value),
              attrs: {}
            };
            obj.attrs.rowSpan = row.rowSpan;
            return obj;
          },
          width: 100
        },
        {
          title: '预估成本',
          dataIndex: 'estimateCost',
          customRender: (value, row) => {
            const obj = {
              children: this.carlengthText(value),
              attrs: {}
            };
            obj.attrs.rowSpan = row.rowSpan;
            return obj;
          },
          width: 100
        }
      ];
    },
    conductLength() {
      return (text) => {
        return text.length > 20 ? `${text.substring(0, 19)}...` : text || '--';
      };
    }
  },
  watch: {
    checkTab() {
      if (this.checkTab === 'have-wiring') {
        this.toSearch();
      }
    },
    refreshTime() {
      this.fetchData();
    }
  },

  created() {
    this.fetchData();
    window.addModal = this.addModal;
  },
  methods: {
    async handleExport() {
      this.exportLoading = true;
      const query = {
        ...filterNull(this.queryForm),
        customerCode: this.$store.state.user.tenantId,
        mdGroupId: this.plan.mdGroupId,
        version: this.plan.version
      };
      const url = '/starbucks/inbound/export';
      const http = new XMLHttpRequest();
      let fromDate = {};
      if (query) {
        fromDate = query;
      }
      http.open('POST', `${Service.SMART_WIRUNG_SERVER}${url}`);
      http.responseType = 'blob';
      http.setRequestHeader('Authorization', getAppToken() || getToken());
      http.setRequestHeader('Token', getAppToken() || getToken());
      http.setRequestHeader('Content-Type', 'application/json');

      http.onreadystatechange = () => {
        if (http.status === 200 && http.readyState === 4) {
          const filename = `线路详情.xlsx`;
          const blob = new Blob([http.response], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
          });
          const csvUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = csvUrl;
          link.download = filename;
          link.click();
        }
      };
      http.send(JSON.stringify(fromDate));
      this.exportLoading = false;
    },
    changeType(item, val) {
      const data = this.feeItem.filter((v) => v.type === val);
      if (data.length > 1) {
        this.$message.warning('已存在相同的项！，请勿重复选择！');
        item.type = null;
      }
    },
    addModal(row) {
      this.addInfo = row;
      this.visible = true;
    },
    deleteFeeItems(index) {
      this.feeItem.splice(index, 1);
    },

    addFeeItems() {
      this.feeItem.push({ name: '' });
    },
    cancelModal() {
      this.feeItem = [{ name: '' }];
      this.visible = false;
    },
    async hideModal() {
      const hasEmptyType = this.feeItem.every((obj) => obj.type && obj.value);
      if (hasEmptyType) {
        // eslint-disable-next-line no-restricted-globals
        const allNumericValues = this.feeItem.every(
          (obj) => !isNaN(obj.value) && typeof obj.value !== 'boolean'
        );
        if (allNumericValues) {
          const feeItems = {
            escortFees: null,
            handlingCharges: null,
            escortTime: null
          };
          this.feeItem.forEach((v) => {
            if (v.type === 'YC') {
              feeItems.escortFees = v.value;
              feeItems.escortTime = v.valueTime || null;
            }
            if (v.type === 'ZX') {
              feeItems.handlingCharges = v.value;
            }
          });
          const query = {
            feeItems,
            unifyOrderCode: this.addInfo.unifyOrderCode
          };
          const nonEmptyValues = this.feeItem.filter(
            (obj) => obj.valueTime !== undefined && obj.valueTime !== ''
          );
          if (nonEmptyValues.length) {
            // eslint-disable-next-line no-restricted-globals
            const numericValueTime = nonEmptyValues.every(
              (obj) =>
                !isNaN(obj.valueTime) && typeof obj.valueTime !== 'boolean'
            );
            if (numericValueTime) {
              const that = this;
              this.$confirm({
                title: '请注意！',
                content: '一旦保存后将不可编辑，是否要继续保存？',
                async onOk() {
                  try {
                    const res = await addOthersFee(query);
                    console.log(11, res);
                    that.$message.success('保存成功！');
                    setTimeout(() => {
                      that.cancelModal();
                      that.fetchData();
                    }, 300);
                  } catch (erro) {
                    console.log(erro);
                  }
                },
                onCancel() {}
              });
            } else {
              this.$message.warning('小时数值必需为数字！');
            }
          } else {
            const that = this;
            this.$confirm({
              title: '请注意！',
              content: '一旦保存后将不可编辑，是否要继续保存？',
              async onOk() {
                try {
                  const res = await addOthersFee(query);
                  console.log(11, res);
                  that.$message.success('保存成功！');
                  setTimeout(() => {
                    that.cancelModal();
                    that.fetchData();
                  }, 300);
                } catch (erro) {
                  console.log(erro);
                }
              },
              onCancel() {}
            });
          }
        } else {
          console.log('数组中至少存在一个value属性不为数字类型');
          this.$message.warning('费用数值项必需为数字！');
        }
      } else {
        this.$message.warning('费用配置项需填写完整！');
      }
    },

    handleCancel() {
      this.$emit('refresh');
      this.fetchData();
    },
    rowClass(record) {
      return record.rowSpanState
        ? `rowSpan${record.resultId}`
        : `rowSpan${record.id}`;
    },
    customRow() {
      return {
        on: {
          mouseenter: (event) => {
            this.mouseAction(event, 'add');
          },
          mouseleave: (event) => {
            this.mouseAction(event, 'remove');
          }
        }
      };
    },
    mouseAction(event, type) {
      const { classList } = event.target;
      let currentClass = '';
      for (let i = 0; i < classList.length; i += 1) {
        if (/rowSpan+/.test(classList[i])) {
          currentClass = classList[i];
          break;
        }
      }
      const eles = document.getElementsByClassName(currentClass);
      for (let i = 0; i < eles.length; i += 1) {
        eles[i].classList[type]('ant-table-row-hover');
      }
    },
    handleTimeChange(value) {
      if (!value.length) {
        const { startCreateTime, endCreateTime, ...restParmas } =
          this.queryForm;
        this.queryForm = {
          ...restParmas
        };
        this.toSearch();
      }
    },
    handleOk(value) {
      const [start, end] = value;
      this.queryForm = {
        ...this.queryForm,
        startCreateTime: start,
        endCreateTime: end
      };
      this.toSearch();
    },
    toSearch() {
      this.pagination.current = 1;
      this.fetchData();
    },
    handleReset() {
      this.queryForm = {
        loadFactorIsRight: '',
        isChanged: ''
      };
      this.createTime = [];
      this.toSearch();
    },
    async fetchData() {
      const parmas = {
        size: this.pagination.pageSize,
        page: this.pagination.current
        // sort: 'line_code__DESC' ////area__ASC
      };
      const { createTime, loadFactorIsRight, isChanged } = this.queryForm;
      console.log(99, this.plan);

      const query = {
        planCode: this.planCode,
        status: PLAN_STATUS.PLANED,
        loadFactorIsRight:
          loadFactorIsRight || (loadFactorIsRight === false ? false : null),
        isChanged: isChanged || (isChanged === '' ? null : isChanged),
        ...filterNull(this.queryForm),
        mdGroupId: this.plan.mdGroupId,
        version: this.plan.version
      };
      if (createTime?.length) {
        const [start, end] = createTime;
        query.startCreateTime = start;
        query.endCreateTime = end;
      }
      const res = await getDetailPage(query, parmas);
      this.renderLine = [];
      // eslint-disable-next-line no-unused-expressions
      res.records.length &&
        res.records.forEach((v, index) => {
          if (index < 1) {
            if (res.records.length > 1) {
              if (v.resultId === res.records[index + 1].resultId) {
                res.records[index].rowSpanState = true;
              }
            }
          }
          if (index > 0) {
            if (v.resultId === res.records[index - 1].resultId) {
              res.records[index].rowSpanState = true;
              res.records[index - 1].rowSpanState = true;
            }
          }
        });
      this.dataList = res.records.map((item) => {
        if (item.rowSpanState) {
          if (!this.renderLine.includes(item.resultId)) {
            const itemList = res.records.filter(
              (row) => row.resultId === item.resultId
            );
            this.renderLine.push(item.resultId);
            return {
              ...item,
              rowSpan: itemList.length
            };
          }
          return {
            ...item,
            rowSpan: 0
          };
        }
        return {
          ...item,
          rowSpan: 1
        };
      });
      this.dataList.forEach((m) => {
        m.addUnifyOrderCode = m.unifyOrderCode;
        if (m.transportType === 'VOLUME') {
          m.vehicleLoadingRatePallet = '--';
          m.vehicleLoadingRateWeight = '--';
          m.vehicleLoadingRateVolume = `${(
            (m.vehicleLoadingRateVolume * 10000) /
            100
          ).toFixed(2)}%`;
        }
        if (m.transportType === 'WEIGHT') {
          m.vehicleLoadingRatePallet = '--';
          m.vehicleLoadingRateWeight = `${(
            (m.vehicleLoadingRateWeight * 10000) /
            100
          ).toFixed(2)}%`;
          m.vehicleLoadingRateVolume = '--';
        }
        if (m.transportType === 'BOARD_NUMBER') {
          m.vehicleLoadingRatePallet = `${(
            (m.vehicleLoadingRatePallet * 10000) /
            100
          ).toFixed(2)}%`;
          m.vehicleLoadingRateWeight = '--';
          m.vehicleLoadingRateVolume = '--';
        }
      });
      this.pagination.total = res.total;
    },
    async onEdit(lineCode) {
      const res = await getPlanInfoPage(
        {
          planCode: this.planCode,
          status: PLAN_STATUS.PLANED,
          lineCode
        },
        { size: 100 }
      );
      this.$refs.HaveWiringDialog.show(res.records);
    },
    onDelete(row, isDialog) {
      this.$confirm({
        title: `是否确认删除该排线组?`,
        onOk: async () => {
          await planLineDelete({
            planCode: this.planCode,
            lineCode: row.lineCode
          });
          this.$message.success('删除成功');
          this.pagination.current = 1;
          this.$emit('refresh');
          if (isDialog) {
            this.$refs.HaveWiringDialog.handleCancel();
            return;
          }
          this.toSearch();
        }
      });
    },
    // 分页信息改变
    tableChange(pagination) {
      let { current } = pagination;
      if (pagination.pageSize !== this.pagination.pageSize) {
        current = 1;
      }
      this.pagination = {
        ...pagination,
        current
      };
      this.fetchData();
    }
  }
};
</script>
<style lang="less" scoped>
.have-wiring {
  /deep/ .ant-table-body-inner {
    padding-right: 0;
  }
  /deep/ .ant-form {
    .ant-form-item {
      width: 100%;
      margin-bottom: 16px;
    }
    .ant-calendar-picker {
      max-width: 100%;
    }
  }
  .form-btn {
    text-align: right;
    /deep/ .ant-btn {
      margin-right: 12px;
    }
  }
  .wiring-table {
    margin-top: 8px;
    .delete-btn {
      margin-left: 16px;
      color: #606266;
    }
  }
  .toopltip_bar {
    position: relative;
    display: inline-block;
    width: 100%;
  }
  /deep/.my_toopltip {
    background: #3f3f3f;
    width: auto;
    min-width: 180px;
    color: #fff;
    position: absolute;
    display: inline-block;
    padding: 10px;
    border-radius: 6px;
    &::after {
      content: '';
      width: 0;
      height: 0;
      position: absolute;
      border-left: 10px solid #3f3f3f;
      border-bottom: 10px solid #3f3f3f;
      transform: rotate(45deg);
      bottom: -4px;
    }
  }
}
.wiring_form {
  /deep/.ant-form-item-label {
    width: 70px;
    label {
      color: #606266;
    }
  }
}
.visible-row {
  padding-bottom: 10px;
  display: flex;
  align-items: center;
}
.action-time {
  color: #afa8a8;
}
.search-btn {
  text-align: right;
}
/deep/.active_bar {
  margin-right: 0 !important ;
}
</style>
